import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=f628d19c"
import script from "./InviteUser.vue?vue&type=script&lang=js"
export * from "./InviteUser.vue?vue&type=script&lang=js"
import style0 from "./InviteUser.vue?vue&type=style&index=0&id=f628d19c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports